import axios from "axios"

export const show = async ({ params }) => {
    var access_token = localStorage.getItem('access_token') ?? ''

    return null
}
